import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNumber'
})
export class IsNumberPipe implements PipeTransform {
  transform(val: any): boolean {
    return (
      (typeof val === 'number' && Number.isFinite(val)) ||
      (typeof val === 'string' && val.trim() !== '' && Number.isFinite(Number(val)))
    );
  }
}
